import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const recognitionSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="anerkennung"
    class=${editorNodeClass(editor, 'section.recognition', 'vp-section vp-recognition-section')}
    style=${editorNodeStyle(editor, 'section.recognition')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.recognition', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.recognition', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.recognition.eyebrow,
        title: content.recognition.title,
        highlight: content.recognition.titleHighlight,
        text: content.recognition.text,
        align: 'center',
        editor,
        elementPrefix: 'recognition',
      })}
      <div
        class=${editorNodeClass(editor, 'recognition.cards.container', 'vp-card-grid vp-card-grid-three')}
        style=${editorNodeStyle(editor, 'recognition.cards.container')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'recognition.cards.container', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'recognition.cards.container', event)}
      >
        ${content.recognition.cards.map(
          (card, index) => html`
            <article
              class=${editorNodeClass(
                editor,
                `recognition.card.${index}`,
                'vp-info-card vp-info-card-light reveal-card',
              )}
              style=${editorNodeStyle(editor, `recognition.card.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `recognition.card.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `recognition.card.${index}`, event)}
            >
              <span
                class=${editorNodeClass(editor, `recognition.card.${index}.icon`, card.iconClass)}
                style=${editorNodeStyle(editor, `recognition.card.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `recognition.card.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `recognition.card.${index}.icon`, event)}
              ></span>
              ${editorSemanticText({
                editor,
                elementId: `recognition.card.${index}.title`,
                fallbackTag: 'h3',
                content: card.title,
              })}
              ${editorSemanticText({
                editor,
                elementId: `recognition.card.${index}.text`,
                fallbackTag: 'p',
                content: card.text,
              })}
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;
